import { optimizeBannerImageUrl, optimizePageBannerImageUrl } from "./image";

export const PAGE_BANNER_TYPES = [
  "about",
  "service",
  "project",
  "gallery",
  "certificate",
  "contact_us",
];

export const ROUTE_BANNER_TYPES = {
  "/about": "about",
  "/services": "service",
  "/projects": "project",
  "/gallery": "gallery",
  "/certifications": "certificate",
  "/contact": "contact_us",
};

const preloadedImages = new Set();
const loadedImages = new Set();

export function preloadPageBannerImage(url) {
  const src = optimizePageBannerImageUrl(url) || url?.trim();
  if (!src || preloadedImages.has(src)) return;
  preloadedImages.add(src);
  const img = new Image();
  img.onload = () => loadedImages.add(src);
  img.onerror = () => {};
  img.src = src;
}

export function preloadPageBannerImages(urls) {
  (urls || []).forEach((url) => preloadPageBannerImage(url));
}

export function preloadBannerImage(url) {
  const src = optimizeBannerImageUrl(url) || url?.trim();
  if (!src || preloadedImages.has(src)) return;
  preloadedImages.add(src);
  const img = new Image();
  img.onload = () => loadedImages.add(src);
  img.onerror = () => {};
  img.src = src;
}

export function preloadBannerImages(banners) {
  (banners || []).forEach((banner) => preloadBannerImage(banner?.image));
}

export function isBannerImageLoaded(url) {
  const src = url?.trim();
  return Boolean(src && loadedImages.has(src));
}

export function loadBannerImage(url) {
  const src = optimizeBannerImageUrl(url) || url?.trim();
  if (!src) return Promise.resolve(false);
  if (loadedImages.has(src)) return Promise.resolve(true);

  return new Promise((resolve) => {
    preloadedImages.add(src);
    const img = new Image();
    img.onload = () => {
      loadedImages.add(src);
      resolve(true);
    };
    img.onerror = () => resolve(false);
    img.src = src;
  });
}

export function waitForFirstBannerImage(urls) {
  const first = (urls || []).map((url) => url?.trim()).find(Boolean);
  if (!first) return Promise.resolve(false);
  return loadBannerImage(first);
}

export function waitForBannerImages(urls) {
  const unique = [...new Set((urls || []).map((url) => url?.trim()).filter(Boolean))];
  if (unique.length === 0) return Promise.resolve([]);
  return Promise.all(unique.map(loadBannerImage));
}

export function preloadPageBannerImageLink(url) {
  const src = optimizePageBannerImageUrl(url) || url?.trim();
  if (!src || typeof document === "undefined") return;
  const existing = document.querySelector(`link[rel="preload"][href="${src}"]`);
  if (existing) return;
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = src;
  document.head.appendChild(link);
}

export function preloadBannerImageLink(url) {
  const src = optimizeBannerImageUrl(url) || url?.trim();
  if (!src || typeof document === "undefined") return;
  const existing = document.querySelector(`link[rel="preload"][href="${src}"]`);
  if (existing) return;
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = src;
  document.head.appendChild(link);
}
